<div class="m-enseigne-card">
  <div class="m-enseigne-card__header">
    <h3 class="m-enseigne-card__title">{{ enseigne().enseigne }}</h3>
    <div class="m-enseigne-card__actions">
      <button class="m-enseigne-card__edit" (click)="onEdit()" [title]="'COMMON.EDIT' | translate">
        <mat-icon>edit</mat-icon>
      </button>
      <button
        class="m-enseigne-card__delete"
        (click)="onDelete()"
        [title]="'COMMON.DELETE' | translate"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <div class="m-enseigne-card__body">
    <div class="m-enseigne-card__row">
      <span class="m-enseigne-card__label">{{ 'ENSEIGNES.CODE_ORG' | translate }} :</span>
      <span class="m-enseigne-card__value">{{ enseigne().codeOrg }}</span>
    </div>
    <div class="m-enseigne-card__row">
      <span class="m-enseigne-card__label">{{ 'ENSEIGNES.PAYS' | translate }} :</span>
      <span class="m-enseigne-card__value">{{ getFormattedGroupedValues('country').join(', ') }}</span>
    </div>
    <div class="m-enseigne-card__row">
      <span class="m-enseigne-card__label">{{ 'ENSEIGNES.PREFIXES' | translate }} :</span>
      <span class="m-enseigne-card__value">{{ getFormattedGroupedValues('prefix').join(', ') }}</span>
    </div>
    <div class="m-enseigne-card__row">
      <span class="m-enseigne-card__label">{{ 'ENSEIGNES.SALESFORCE_KEYS' | translate }} :</span>
      <span class="m-enseigne-card__value">{{
        getFormattedGroupedValues('salesforceRoutingCode').join(', ')
      }}</span>
    </div>
    <div class="m-enseigne-card__row">
      <span class="m-enseigne-card__label">{{ 'ENSEIGNES.SAP_KEYS' | translate }} :</span>
      <span class="m-enseigne-card__value">{{
        getFormattedGroupedValues('sapRoutingCode').join(', ')
      }}</span>
    </div>
    <div class="m-enseigne-card__row">
      <span class="m-enseigne-card__label">{{ 'ENSEIGNES.TRANSPORT_GROUPS' | translate }} :</span>
      <app-transport-group-chips [groups]="getAllTransportGroups()" />
    </div>
  </div>
</div>
